<template>
    <main class="layout-page-content">

        <ListenDialog v-model="isShowUploadFile" @updateSuccess="listenUpdateSuccess"></ListenDialog>
        <QuestionDialog v-model="isOverlayVisible" @genTestSuccess="listenUpdateSuccess"></QuestionDialog>
        <CheckInfoDialog :is-visible="showAppointDetail"
                         :appointment-data="selectedAppointment"
                         :appointment-type="detailType"
                         @close="showAppointDetail = false" />
        <div v-if="isSmallScreen">
            <CommonHeader></CommonHeader>
            <AddVisitorDialog v-model="isVisitorVisible" @addVConfirm="addVisitorConfirm"> </AddVisitorDialog>
            <div class="mobile-container">
                <!-- 顶部功能按钮区 -->
                <div class="top-buttons mt-3">
                    <div v-for="(item, index) in topButtonList"
                         :key="index"
                         class="button-item"
                         @click="handleButtonClick(item)">
                        <i v-if="index==0" class="fa fa-pen-square  text-blue-600 text-4xl" />
                        <i v-else-if="index==1" class="fa fa-file-alt  text-blue-600 text-4xl"></i>
                        <i v-else-if="index==2" class="fa fa-user-friends  text-blue-600 text-4xl"></i>
                        <i v-else-if="index==3" class="fa fa-user text-blue-600 text-4xl"></i>
                        <p class="button-text font-bold">{{ item.text }}</p>
                    </div>
                </div>
                <transition name="fade">
                    <div v-if="isVisitorListVisible"
                         class="fixed inset-0 bg-black bg-opacity-50 z-40"
                         @click="isVisitorListVisible = false"></div>
                </transition>
                <transition name="slide">
                    <div v-if="isVisitorListVisible"
                         class="fixed inset-y-0 left-0 w-full max-w-md bg-white z-50 shadow-xl overflow-y-auto">
                        <!-- 顶部栏 -->
                        <div class="sticky top-0 bg-white z-10 p-4 border-b flex flex-row justify-between items-center">
                            <h2 class="font-bold text-xl text-stone-700">来访者</h2>
                            <button @click="isVisitorListVisible = false" class="text-gray-500">
                                <i class="fa fa-times text-xl"></i>
                            </button>
                        </div>

                        <!-- 搜索框 -->
                        <div class="p-4">
                            <div class="relative">
                                <el-input v-model="searchVisitorKey"
                                          @input="handleSearchVisitor"
                                          placeholder="搜索来访者"
                                          class="w-full">
                                    <template #prefix>
                                        <i class="fa fa-search text-gray-400"></i>
                                    </template>
                                </el-input>
                            </div>
                        </div>

                        <!-- 新增来访者按钮 -->
                        <div class="px-4 pb-3">
                            <button @click="handleAddVisitor"
                                    class="w-full bg-blue-600 text-white py-2 px-4 rounded-lg flex flex-row  items-center justify-center">
                                <i class="fa fa-user-plus mr-2"></i>
                                <span>新增来访者</span>
                            </button>
                        </div>

                        <!-- 来访者列表 -->
                        <div class="pb-20">
                            <div v-for="visitors in visitorShowList" :key="visitors.index" class="px-4">
                                <div class="py-2 border-t">
                                    <h3 class="text-lg font-bold text-stone-700">{{ visitors.index }}</h3>
                                </div>
                                <div v-for="v in visitors.vinfos" :key="v.vid">
                                    <a @click="gotoVisitor(v)" class="block">
                                        <div class="flex flex-row items-center py-3 px-2 hover:bg-gray-50 active:bg-gray-100">
                                            <div class="v-avatar w-10 h-10 rounded-full flex items-center justify-center"
                                                 :style="{ backgroundColor: v.color }">
                                                <span class="text-white font-medium">{{ v.visitorName.charAt(0) }}</span>
                                            </div>
                                            <div class="ml-3 flex-1 min-w-0">
                                                <div class="text-base font-medium text-gray-800 truncate">{{ v.visitorName }}</div>
                                                <!-- 可添加更多信息 -->
                                            </div>
                                            <i class="fa fa-chevron-right text-gray-400 ml-2"></i>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <!-- 导航栏 -->
                <div class="tab-bar">
                    <div v-for="(tab, tabIndex) in tabs"
                         :key="tabIndex"
                         :class="['tab-item','text-lg font-blod', { active: dyncSelect === tab.value }] "
                         @click="setPage(tab.value)">
                        {{ tab.label }}
                    </div>
                </div>

                <!-- 内容列表区 -->
                <div class="content-list " v-if="activityList.length>0">
                    <div v-for="(item, listIndex) in  activityList"
                         :key="listIndex"
                         class="content-item" @click="activityClick(listIndex)">
                        <div class="item-header">
                            <div class="flex items-center justify-center rounded-full p-2 bg-purple-600 text-white shadow-lg">
                                <i v-if="item.type=='test'" class="fa fa-pen-square" />
                                <i v-else-if="item.type=='train'" class="fa fa-user-friends text-base"></i>
                                <i v-else-if="item.type=='listen'" class="fa fa-file-alt"></i>
                            </div>
                              <!--<span class="tag" :style="{ backgroundColor: item.tagBg }">{{ item.tipinfo }}</span>-->
                            <span class="item-title">{{ item.activityTitle }}</span>
                        </div>
                        <div class="flex flex-row justify-between">
                            et
                            <p class="item-subtitle">{{ item.visitorName }}</p>
                            <p :class="getMapColor(item.state)" class="rounded px-2 text-sm p-1 whitespace-nowrap ">{{ item.state }}</p>
                        </div>
                        <p class="item-desc">{{ item.abstract }}</p>
                        <p class="item-time">{{ item.createTime }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <AddVisitorDialog v-model="isVisitorVisible" @addVConfirm="addVisitorConfirm"> </AddVisitorDialog>

            <!-- add visitor-->
            <!--<el-dialog title="新增来访者" top="30px" :visible.sync="isVisitorVisible" width="600px" @close="addVisitorClose">
        <div class="p-2">
            <el-form ref="formRef" :model="form_addvisitor" :rules="rules">
                <el-form-item label="姓名" prop="visitorName">
                    <el-input v-model="form_addvisitor.visitorName" placeholder="请输入姓名" />
                </el-form-item>
                <el-form-item label="生理性别" prop="gender">
                    <el-radio-group v-model="form_addvisitor.gender">
                        <el-radio label="男">男</el-radio>
                        <el-radio label="女">女</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="年龄" prop="age">
                    <el-input v-model="form_addvisitor.age" placeholder="请输入年龄" />
                </el-form-item>

                <el-form-item label="首次访问时间" prop="visitDate">
                    <el-date-picker v-model="form_addvisitor.visitDate" type="datetime" clearable placeholder="选择日期时间" />
                </el-form-item>

                <el-form-item label="联系方式">
                    <el-input v-model="form_addvisitor.contact" placeholder="请输入联系方式" />
                </el-form-item>
                <el-form-item label="主要症状">
                    <el-input v-model="form_addvisitor.symptoms" placeholder="请输入主要症状" />
                </el-form-item>
                <el-form-item label="来访背景关键信息">
                    <el-input type="textarea" :rows="4" v-model="form_addvisitor.backgroundInfo" placeholder="请输入来访背景关键信息" />
                </el-form-item>-->
            <!-- 按钮 -->
            <!--<div class="flex justify-end">
                        <el-button type="text" @click="closeDialog">取消</el-button>
                        <el-button type="primary" @click="submitAddVisitorForm">提交</el-button>
                    </div>
                </el-form>

            </div>
        </el-dialog>-->
            <div id="app" class="z-1">
                <header class=" fixed sticky top-0 left-0 right-0 h-[60px] header_style text-white flex z-10 items-center justify-between p-4 shadow">
                    <div class="flex items-center">
                        <img src="@/assets/logo.png" alt="Logo" class="h-8 mr-2" />
                        <!--<span class="text-xl">识心智能</span>-->
                    </div>
                    <RecordModule v-model="isRecordVisible" />
                    <div v-if="isLoggedIn()" class="relative">
                        <img alt="User avatar" class="w-10 h-10 rounded-full cursor-pointer " height="40"
                             src="@/assets/user.png" width="40" @mouseover="showUserMenu" />
                        <div @mouseleave="hideUserMenu"
                             class="absolute  right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg"
                             v-show="isUserMenuVisible">
                            <a class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" href="#">
                                {{ user.nickname }}
                            </a>
                            <a class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" href="#">
                                {{ user.phone }}
                            </a>
                            <a class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" href="#" @click="logout">
                                退出登录
                            </a>
                        </div>
                    </div>
                    <div v-else>
                        <button @click="showLogin"
                                class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                            登录
                        </button>
                        <button @click="showRegister"
                                class="ml-5 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                            注册
                        </button>
                    </div>
                </header>

                <!--login-->
                <el-dialog :visible.sync="loginForm.dialogFormVisible" :width="dialogWidth" title="登录">
                    <el-form :model="loginForm" label-position="top" ref="loginForm">
                        <el-form-item label="手机号" :error="loginForm.phoneError">
                            <el-input placeholder="请输入手机号" v-model="loginForm.phone" @blur="validateLoginPhone"
                                      @input="validateLoginPhone" maxlength="11">
                                <template #prepend="">
                                    <el-select placeholder="+86" disabled style="width: 80px;"
                                               v-model="loginForm.phonePrefix">
                                        <el-option label="+86" value="+86" />
                                    </el-select>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="输入验证码" :error="loginForm.verificationCodeError">
                            <el-input placeholder="请输入验证码" v-model="loginForm.verificationCode"
                                      @blur="validateLoginVerificationCode" @input="validateLoginVerificationCode"
                                      maxlength="6">
                                <template #append="">
                                    <el-button @click="getVerificationCode('loginForm')"
                                               :disabled="loginForm.isCountingDown" type="primary">
                                        {{
                        loginForm.verificationButtonText
                                        }}
                                    </el-button>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="submitLoginForm" class="w-full bg-primary"
                                       type="primary">立即登录</el-button>
                        </el-form-item>
                    </el-form>
                    <p class="text-center mt-4">
                        没有账号？
                        <el-link type="primary" @click="showRegister">立即注册</el-link>
                    </p>
                </el-dialog>
                <!--注册-->
                <el-dialog :visible.sync="form.dialogFormVisible" :width="dialogWidth" title="注册">
                    <el-form :model="form" label-position="top" ref="form">
                        <el-form-item label="手机号" :error="form.phoneError">
                            <el-input placeholder="请输入手机号" v-model="form.phone" @blur="validatePhone"
                                      @input="validatePhone" maxlength="11">
                                <template #prepend="">
                                    <el-select placeholder="+86" disabled style="width: 80px;"
                                               v-model="form.phonePrefix">
                                        <el-option label="+86" value="+86" />
                                    </el-select>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="输入验证码" :error="form.verificationCodeError">
                            <el-input placeholder="请输入验证码" v-model="form.verificationCode"
                                      @blur="validateVerificationCode" @input="validateVerificationCode" maxlength="6">
                                <template #append="">
                                    <el-button @click="getVerificationCode('form')" :disabled="form.isCountingDown"
                                               type="primary">{{ form.verificationButtonText }}</el-button>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="昵称" :error="form.nicknameError">
                            <el-input placeholder="请输入 20 字符内的昵称" v-model="form.nickname" @blur="validateNickname"
                                      @input="validateNickname" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item :error="form.agreementError">
                            <el-checkbox v-model="form.agreement">
                                我已阅读并同意
                                <el-link href="#" type="primary">《用户协议》</el-link>
                                与
                                <el-link href="#" type="primary">《隐私政策》</el-link>
                            </el-checkbox>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="submitForm" class="w-full bg-primary" type="primary">立即注册</el-button>
                        </el-form-item>
                    </el-form>
                    <p class="text-center mt-4">
                        已有账号？
                        <el-link type="primary" @click="showLogin">直接登录</el-link>
                    </p>
                </el-dialog>
                <div class="v-layout z-1 mt-[60px] md:mt-0">
                    <main class="flex flex-col md:flex-row h-[calc(100vh-60px)] overflow-hidden">
                        <!-- 侧边栏 - 移动端优化 -->
                        <nav class="w-full md:w-72 bg-white shadow-lg md:pr-4 md:pt-4">
                            <div class="mobile-header md:hidden flex justify-between items-center p-2 border-b">
                                <h2 class="font-bold text-xl text-stone-700">来访者</h2>
                                <button @click="isVisitorVisible = true" class="text-blue-600 text-sm">
                                    <i class="fa fa-user-plus mr-1"></i>
                                    <span>新增</span>
                                </button>
                            </div>

                            <div class="md:block" :class="{ 'hidden': !mobileNavOpen }">
                                <!-- 原有侧边栏内容 -->
                                <div class="flex  flex-col ">
                                    <div class="mb-7 px-6 flex justify-between items-center" @click="isVisitorVisible = true">
                                        <h2 class=" font-bold text-2xl text-stone-700">来访者</h2>
                                        <button type="button" class="flex items-center text-blue-600 -mr-6">
                                            <i class="fa fa-user-plus" />
                                            <span>新增来访者</span>
                                        </button>
                                    </div>
                                    <div class="flex-grow mb-4 px-4 transition duration-300 ease-in-out">
                                        <div class="relative">
                                            <el-input class="flex-grow p-2 focus:outline-none"
                                                      v-model="searchVisitorKey"
                                                      @input="handleSearchVisitor" placeholder="搜索来访者">
                                                <template #prefix>
                                                    <i class="fa fa-search text-gray-800 p-4 pt-5"></i>
                                                </template>
                                            </el-input>
                                        </div>
                                    </div>
                                    <div class="overflow-y-auto h-[calc(100vh-240px)]">
                                        <div class="bg-transparent">
                                            <div class="bg-transparent px-4" v-for="visitors in visitorShowList" :key="visitors.index">
                                                <div class="px-4 flex justify-start">
                                                    <h3 class="text-l font-bold text-stone-700">{{ visitors.index }}</h3>
                                                </div>
                                                <div v-for="v in visitors.vinfos" :key="v.vid">
                                                    <a @click="gotoVisitor(v)" class="block">
                                                        <div class="flex items-center bg-transparent rounded-full my-2 p-2 hover:bg-gray-100">
                                                            <div class="v-avatar w-8 h-8 bg-blue-200 rounded-full flex items-center justify-center" :style="{ backgroundColor:v.color }">
                                                                <span class="text-blue-600">{{ v.visitorName.charAt(0) }}</span>
                                                            </div>
                                                            <div class="ml-2">
                                                                <div class="text-base font-medium text-gray-500">{{ v.visitorName }}</div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>

                        <!-- 顶部按钮 -->
                        <div  class="flex flex-col h-full w-1/2 pt-4">
                            <div v-if="tempflag" class="px-4 mb-8 text-gray-700 font-semibold flex justify-between items-center">
                                <h4 v-if="pageSelect === 0" class="text-2xl">动态</h4>
                                <h4 v-else class="text-2xl">预约表</h4>
                                <div class="shadow-inner rounded-lg bg-gray-200 p-1 mx-auto">
                                    <div class="flex space-x-2" role="tablist">
                                        <button type="button" class="flex items-center px-6 py-2   text-gray-700 hover:bg-sky-200 rounded-lg"
                                                role="tab"
                                                :class="pageSelect === 0 ? 'bg-white': 'bg-gray-200'"
                                                @click="setActiveTab(0)"
                                                value="result">
                                            <i class="far fa-file-alt" />
                                            <span class="ml-2">动态</span>
                                        </button>
                                        <button type="button" class="flex items-center px-6 py-2 text-gray-700 hover:bg-sky-200 rounded-lg relative"
                                                role="tab"
                                                :class="pageSelect === 1 ? 'bg-white' : 'bg-gray-200'"
                                                @click="setActiveTab(1)"
                                                value="transcript">
                                            <i class="fas fa-newspaper"></i>
                                            <span class="ml-2">预约表</span>
                                            <div v-if="newAppointments > 0"
                                                    class="absolute p-2 -top-1 -right-1 flex items-center justify-center bg-red-500 text-white text-xs rounded-full h-5 w-5"
                                                    title="新预约">
                                                {{ newAppointments }}
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-else  class="px-4 mb-8 text-gray-700 font-semibold flex justify-between items-center">
                                <h4 class="text-2xl">动态</h4>
                            </div>
                            <div class="relative overflow-hidden">
                                <div class="flex transition-transform duration-300" :style="`transform: translateX(-${pageSelect * 100}%)` ">
                                    <div class="w-full flex-shrink-0 ">
                                        <div class="flex-1 overflow-hidden">
                                            <div class="h-full">
                                                <div class="h-full flex flex-col">
                                                    <div class="px-4 mb-4">
                                                        <div class="flex space-x-2 " role="tablist">
                                                            <button v-for="item in tabs"
                                                                    :key="item.value"
                                                                    type="button"
                                                                    class="hover:text-indigo-600 hover:bg-cyan-200 rounded-lg p-1 px-6 text-sm"
                                                                    :class="{'bg-blue-700 text-white': dyncSelect === item.value, ' text-black': dyncSelect !== item.value}"
                                                                    role="tab"
                                                                    :aria-selected="dyncSelect === item.value"
                                                                    :value="item.value"
                                                                    @click="setPage(item.value)">
                                                                <span class="flex items-center">
                                                                    <div class="text-truncate font-medium">{{ item.label }}</div>
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="overflow-y-auto scrollable pb-8" @scroll="handleScroll" ref="act_container">
                                                        <div v-for="(activity,index) in activityList" :key="index" class="px-4 ">
                                                            <div class="bg-white shadow rounded-lg mb-5 hover:bg-gray-200" @click="activityClick(index)">
                                                                <div class="p-5">
                                                                    <div class="flex justify-between items-center">
                                                                        <div class="flex items-center">
                                                                            <div class="bg-[#FBF0F2] rounded">
                                                                                <img src="@/assets/sim.png" class="h-8 w-8" alt="Icon">
                                                                            </div>
                                                                            <h4 class="px-4 font-bold text-gray-600">{{activity.tipinfo}}</h4>
                                                                        </div>
                                                                        <span :class="getMapColor(activity.state)" class="rounded px-2 text-sm p-1">{{activity.state}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="px-6 text-left" style="color: rgba(47, 43, 61, 0.55) ">{{activity.activityTitle}}</div>
                                                                <div class="ml-3 mr-3 mt-2 px-5 py-2 text-gray-300 text-left rounded-lg text-sm" style="background-color: #f3f3f4  ;color:rgba(47, 43, 61, 0.7) ">
                                                                    {{activity.abstract}}
                                                                </div>
                                                                <div class="flex  items-center px-6  pb-4 pt-2">
                                                                    <div class="flex items-center">
                                                                        <div class="bg-blue-100 text-yellow-800 rounded-full w-8 h-8 flex items-center justify-center">
                                                                            <span>{{activity.visitorName.charAt(0)}}</span>
                                                                        </div>
                                                                        <div class="text-xs text-gray-600 px-2">{{activity.visitorName}}</div>
                                                                    </div>
                                                                    <div class="text-xs px-4 text-gray-400">{{activity.createTime}}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="freshState === 'error'" class="error-message pb-8">
                                                            加载失败，点击<a @click.prevent="retryLoading" class="text-blue-500 cursor-pointer ">重试</a>
                                                        </div>
                                                        <div v-else-if="freshState === 'loading'" class="loading-indicator pb-8">
                                                            加载中...
                                                        </div>
                                                        <div v-else-if="freshState === 'complete'" class="no-more-data pb-8">
                                                            没有更多数据了
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="tempflag" class="w-full flex-shrink-0   flex justify-center">
                                        <div class="h-full w-full ">
                                            <div>
                                                <div class="p-2 mt-2 ml-4 text-base bg-blue-600 text-white rounded-lg w-32
                                                    hover:bg-blue-400 cursor-pointer
                                                    transition-transform transform hover:-translate-y-1 "
                                                     @click="gotoPlatform">预约管理平台</div>
                                                <div class="text-sm text-gray-600">
                                                    此处仅展示最近10条记录
                                                </div>
                                            </div>
                                            
                                            <div class="h-full flex flex-col mt-2 ">
                                                <div class="overflow-y-auto scrollable pb-8 " @scroll="handleScroll" ref="act_container">
                                                    <div v-for="(appointment,index) in appointments" :key="index" class="px-4 mb-4">
                                                        <div class="bg-white shadow rounded-lg mb-4 hover:bg-gray-200" @click="appointmentClick(index)">
                                                            <div class="p-5">
                                                                <div class="flex justify-between items-center">
                                                                    <div class="flex items-center">
                                                                        <div class="bg-[#FBF0F2] rounded">
                                                                            <img src="@/assets/sim.png" class="h-8 w-8" alt="Icon">
                                                                        </div>
                                                                        <h4 class="px-4 font-bold text-gray-600">{{appointment.resvType ==="edu" ?"教育预约":"音疗预约"}}</h4>
                                                                    </div>
                                                                    <span :class="getMapColor(appointment.state)" class="rounded px-2 text-sm p-1">{{getMapState(appointment.state)}}</span>
                                                                </div>
                                                            </div>
                                                            <div class="px-6 text-left" style="color: rgba(47, 43, 61, 0.55) ">{{getInterestStr(appointment)}}</div>
                                                            <div class="ml-3 mr-3 mt-2 px-5 py-2 text-gray-300 text-left rounded-lg text-sm" style="background-color: #f3f3f4  ;color:rgba(47, 43, 61, 0.7) ">
                                                                <div>公司/机构：{{appointment.organization}}</div>
                                                                <div>{{appointment.other?appointment.other:"无其他需求"}}</div>
                                                            </div>
                                                            <div class="flex  items-center px-6  pb-4 pt-2">
                                                                <div class="flex items-center">
                                                                    <div class="bg-blue-100 text-yellow-800 rounded-full w-8 h-8 flex items-center justify-center">
                                                                        <span>{{appointment.name.charAt(0)}}</span>
                                                                    </div>
                                                                    <div class="text-xs text-gray-600 px-2">{{appointment.name}}</div>
                                                                </div>
                                                                <div class="text-xs px-4 text-gray-400">{{appointment.submit_time}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="freshState === 'error'" class="error-message pb-8">
                                                        加载失败，点击<a @click.prevent="getAppointList" class="text-blue-500 cursor-pointer ">重试</a>
                                                    </div>
                                                    <div v-else-if="freshState === 'loading'" class="loading-indicator pb-8">
                                                        加载中...
                                                    </div>
                                                    <div v-else-if="freshState === 'complete'" class="no-more-data pb-8 mb-5">
                                                        更多数据请到 <b>预约管理平台</b> 查看.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--<div class="empty-container center flex-col ">-->
                                        <!--<div class="empty-icon pt-40">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="134" height="161" fill="none"><path fill="#EAEEF9" d="M64.424 118.867c27.373 0 49.566-22.193 49.566-49.664 0-27.472-22.29-49.664-49.566-49.664-27.374 0-49.566 22.192-49.566 49.664 0 27.471 22.192 49.664 49.566 49.664"></path><path stroke="#D6DCE8" stroke-dasharray="4 4" stroke-miterlimit="10" stroke-width="2" d="M93.634 19.54C83.242 40.021 67.989 48.17 54.009 53.035c-3.245 1.145-6.776 2.147-10.116 1.288s-6.25-4.246-5.344-7.585c.811-3.1 4.82-4.627 7.73-3.387 2.958 1.24 4.58 4.675 4.294 7.871s-2.242 6.011-4.724 7.967c-2.528 1.956-5.534 3.149-8.588 4.055-6.728 2.004-13.742 2.958-20.279 5.486-6.584 2.529-12.835 7.06-15.078 13.692C.282 87.145.95 92.488 3.05 96.973c2.099 4.484 5.678 8.253 9.686 11.258 6.155 4.58 13.741 7.442 21.376 7.251 7.634-.191 15.364-3.53 20.087-9.541 4.724-6.01 6.108-14.74 2.768-21.658-2.29-4.77-7.491-8.682-12.692-7.537-4.104.954-7.11 4.96-7.54 9.207-.428 4.245 1.432 8.444 4.2 11.592 2.767 3.196 6.441 5.438 10.258 7.394 5.583 2.815 12.168 4.962 17.941 2.576 5.487-2.242 8.684-7.919 10.784-13.405 2.099-5.486 3.673-11.449 7.49-15.981 4.581-5.438 12.31-7.967 19.23-6.345 6.918 1.622 12.739 7.347 14.457 14.216 1.336 5.343-.286 12.022-5.296 14.36-3.913 1.86-8.732.524-12.12-2.147s-5.678-6.488-7.873-10.209"></path><g filter="url(#a)"><path fill="url(#b)" d="M55.179 42.372c8.353 2.828 17.418-1.652 20.246-10.005S73.773 14.948 65.419 12.12c-8.353-2.828-17.418 1.652-20.246 10.006-2.828 8.353 1.652 17.418 10.006 20.246"></path></g><path fill="#989FB0" d="M59.756 28.85a1.693 1.693 0 1 0 1.086-3.208 1.693 1.693 0 0 0-1.086 3.207"></path><path fill="#989FB0" fill-rule="evenodd" d="M60.682 26.116a1.193 1.193 0 1 0-.765 2.26 1.193 1.193 0 0 0 .764-2.26m-2.46.427a2.193 2.193 0 1 1 4.154 1.406 2.193 2.193 0 0 1-4.154-1.406" clip-rule="evenodd"></path><path stroke="#989FB0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="m62.5 20.5-1.5 5M62.083 27.254l3.417.246"></path><path fill="#989FB0" d="M64.075 17.77c.26-.124.358-.448.219-.724-.14-.276-.464-.4-.725-.275-.26.124-.358.448-.219.724.14.276.464.4.725.275"></path><path fill="#989FB0" fill-rule="evenodd" d="M63.803 17.233c-.02.009-.027.034-.017.054.01.021.035.03.055.021.02-.01.027-.034.017-.055-.011-.02-.035-.03-.055-.02m-.889.47c-.269-.53-.08-1.155.422-1.394.5-.24 1.125-.002 1.394.529.268.53.08 1.155-.422 1.394-.5.239-1.125.002-1.394-.529" clip-rule="evenodd"></path><path fill="#989FB0" d="M57.317 37.705c.26-.125.359-.449.219-.725s-.464-.399-.724-.275c-.261.125-.359.449-.22.725.14.276.465.399.725.275"></path><path fill="#989FB0" fill-rule="evenodd" d="M57.045 37.167c-.02.01-.027.034-.017.055.011.02.035.03.055.02s.027-.033.017-.054-.035-.03-.055-.02m-.889.47c-.268-.53-.08-1.154.422-1.394.501-.239 1.125-.002 1.394.53.268.53.08 1.154-.421 1.393-.502.24-1.126.003-1.395-.528" clip-rule="evenodd"></path><path fill="#989FB0" d="M50.72 24.383c.26-.125.359-.449.219-.725s-.464-.399-.724-.275c-.26.125-.359.449-.22.725.14.276.465.399.725.275"></path><path fill="#989FB0" fill-rule="evenodd" d="M50.448 23.845c-.02.01-.027.034-.016.055s.035.03.054.02c.02-.009.028-.033.017-.054s-.035-.03-.055-.02m-.888.47c-.269-.53-.08-1.155.421-1.393.501-.24 1.126-.003 1.394.528.269.531.08 1.155-.421 1.394-.501.24-1.126.003-1.394-.528" clip-rule="evenodd"></path><path fill="#989FB0" d="M70.655 31.14c.26-.124.358-.448.219-.724-.14-.276-.464-.399-.725-.275s-.358.449-.219.725c.14.276.464.399.725.274"></path><path fill="#989FB0" fill-rule="evenodd" d="M70.383 30.603c-.02.01-.027.034-.016.055s.035.03.054.02c.02-.009.027-.033.017-.054s-.035-.03-.055-.02m-.888.47c-.27-.53-.08-1.155.42-1.394.502-.239 1.126-.002 1.395.53.269.53.08 1.154-.421 1.393-.502.24-1.126.003-1.394-.528" clip-rule="evenodd"></path><path fill="#EAEEF9" d="m12.3 47.098 2.643-.796c.19-.056.19-.334 0-.39l-2.642-.795a.19.19 0 0 1-.136-.136l-.797-2.636c-.055-.191-.333-.191-.389 0l-.796 2.636a.19.19 0 0 1-.136.136l-2.635.796c-.192.055-.192.333 0 .389l2.642.796a.19.19 0 0 1 .135.136l.797 2.642c.055.191.333.191.389 0l.796-2.642a.17.17 0 0 1 .13-.136M96.555 16.173l2.702.56c.195.043.328-.201.186-.341l-1.942-1.96a.19.19 0 0 1-.055-.184l.557-2.697c.043-.195-.201-.327-.341-.185l-1.958 1.936a.19.19 0 0 1-.184.055l-2.696-.557c-.195-.043-.327.201-.186.341l1.943 1.96a.19.19 0 0 1 .054.185l-.56 2.702c-.043.194.201.327.342.185l1.96-1.942a.17.17 0 0 1 .178-.058"></path><path fill="#D6DCE8" d="m94.895 83.013 2.065-1.831c.15-.13.033-.383-.164-.353l-2.732.385a.19.19 0 0 1-.18-.066l-1.829-2.058c-.13-.15-.383-.034-.353.163l.383 2.726a.19.19 0 0 1-.066.18l-2.059 1.83c-.15.13-.034.382.163.352l2.733-.385a.19.19 0 0 1 .18.066l1.83 2.064c.132.15.384.034.354-.163l-.385-2.732a.17.17 0 0 1 .06-.178M73.872 64.326l2.311-.697c.168-.048.168-.291 0-.34l-2.311-.697a.17.17 0 0 1-.12-.118l-.696-2.307c-.049-.167-.292-.167-.34 0l-.697 2.307a.17.17 0 0 1-.119.118l-2.306.697c-.168.049-.168.292 0 .34l2.312.697c.059.016.102.06.118.119l.697 2.311c.049.168.292.168.34 0l.697-2.311a.15.15 0 0 1 .114-.119M29.512 96.762l2.311-.797c.168-.055.168-.333 0-.389l-2.311-.796a.18.18 0 0 1-.119-.136l-.697-2.636c-.048-.19-.292-.19-.34 0l-.697 2.636a.18.18 0 0 1-.119.136l-2.306.796c-.168.056-.168.334 0 .39l2.312.796a.18.18 0 0 1 .119.135l.696 2.642c.049.192.292.192.34 0l.697-2.642a.16.16 0 0 1 .114-.135M25.692 57.672l1.652-.498c.12-.035.12-.208 0-.243l-1.652-.498a.12.12 0 0 1-.084-.084L25.11 54.7c-.035-.12-.209-.12-.243 0l-.498 1.648a.12.12 0 0 1-.085.084l-1.647.498c-.12.035-.12.208 0 .243l1.651.498a.12.12 0 0 1 .085.085l.498 1.65c.034.12.208.12.243 0l.497-1.65a.11.11 0 0 1 .081-.085"></path><path fill="#EAEEF9" d="m120.831 58.762 1.651-.497c.119-.035.119-.209 0-.243l-1.651-.498a.12.12 0 0 1-.085-.085l-.498-1.647c-.035-.12-.208-.12-.243 0l-.498 1.647a.12.12 0 0 1-.085.085l-1.647.498c-.12.034-.12.208 0 .243l1.651.497a.12.12 0 0 1 .085.085l.498 1.651c.035.12.208.12.243 0l.498-1.65a.11.11 0 0 1 .081-.086"></path><path fill="#D6DCE8" d="m37.898 34.654 1.65-.498c.12-.035.12-.208 0-.243l-1.65-.498a.12.12 0 0 1-.085-.084l-.498-1.648c-.035-.12-.208-.12-.243 0l-.498 1.648a.12.12 0 0 1-.085.084l-1.647.498c-.12.035-.12.208 0 .243l1.651.498a.12.12 0 0 1 .085.085l.498 1.65c.034.12.208.12.243 0l.497-1.65a.11.11 0 0 1 .081-.085"></path><path fill="#EAEEF9" d="m13.307 90.103 1.65-.497c.12-.035.12-.209 0-.243l-1.65-.498a.12.12 0 0 1-.085-.085l-.498-1.647c-.035-.12-.208-.12-.243 0l-.498 1.647a.12.12 0 0 1-.085.085l-1.647.498c-.12.034-.12.208 0 .243l1.651.497a.12.12 0 0 1 .085.085l.498 1.651c.035.12.208.12.243 0l.498-1.65a.11.11 0 0 1 .08-.086"></path><path fill="#F1F3F9" stroke="#D6DCE8" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.978" d="M74.535 109.547s-10.114 9.378-10.793 9.426c-.45.173-4.428 1.823-6.963 2.888l-.67-.957c-.336-.478-.672-.956-.978-1.596.124-.23.18-.556.238-.881 1.297-4.049 5.329-10.301 13.826-9.985z"></path><g filter="url(#c)"><path fill="url(#d)" d="m58.692 64.59 3.287 4.686c.939 1.339 1.581 2.458 2.07 3.969 1.833 4.85 1.15 10.18-1.372 14.517-.468.756-.707 1.637-.59 2.412.019.842.269 1.808.805 2.573 1.074 1.53 2.873 2.265 4.681 1.995 5.808-1.078 11.78.725 15.87 5.132.499.506.9 1.08 1.37 1.749l3.287 4.686c.403.573.71 1.214 1.045 1.692l-28.112 19.721c-.43-.411-.9-1.08-1.236-1.559l-3.286-4.685c-.336-.478-.576-1.023-.911-1.501-.134-.191-.24-.545-.441-.832-2.589-5.318-2.28-11.384.682-16.315.936-1.513.79-3.551-.283-5.08-.47-.67-1.197-1.301-1.982-1.606-.067-.096-.163-.029-.163-.029-.785-.305-1.627-.285-2.469-.265-3.903.74-7.903.122-11.512-1.768-.92-.497-1.839-.994-2.634-1.72-.23-.124-.43-.411-.565-.602-.862-.823-1.79-1.74-2.529-2.792l-3.286-4.685-.336-.478L58.385 63.95c.106.354.173.45.307.64"></path></g><path fill="#BAC3D1" d="m56.53 84.084-11.167 8.69-5.768 1.336c-.92-.497-1.838-.993-2.633-1.72-.23-.124-.431-.41-.566-.602 3.086-5.16 5.924-8.436 14.18-10.09 1.388-.26 2.68-.452 4.229-.684 13.796-1.688 1.725 3.07 1.725 3.07"></path><path fill="#D5DDEA" d="M64.117 73.34c1.832 4.85 1.149 10.18-1.373 14.517-.468.757-.706 1.637-.59 2.412l-.096.067c-1.53 1.074-1.93 3.351-.857 4.881l9.995 14.247-2.773 1.946-10.062-14.343c-1.073-1.53-3.255-1.997-4.88-.856-.785-.306-1.627-.286-2.47-.266-3.903.74-7.903.123-11.512-1.768-.92-.497-1.838-.993-2.633-1.72 8.514-1.692 11.38-6.556 13.586-10.53.716-1.215 1.337-2.364 2.025-3.417 2.723-4.05 6.74-5.442 11.64-5.17"></path><path fill="#D5DDEA" d="m84.718 101.69 3.286 4.686c.403.573.71 1.214 1.045 1.692l-25.052 17.574-4.602-.052-2.952-4.207c-.335-.479-.67-.957-.91-1.502-.135-.191-.24-.545-.441-.832.095-.067.162.029.258-.038.163.028.258-.039.354-.106 9.318-1.971 11.81-7.571 14.169-11.937.372-.689.84-1.446 1.28-2.039 2.885-4.022 7.065-5.385 12.127-5.084.47.669.968 1.176 1.438 1.845"></path><path fill="url(#e)" d="M60.989 64.406 29.626 86.407c-.669.47-1.645.299-2.048-.275l-2.146-3.06c-.47-.67-.231-1.55.438-2.02l31.458-22.068c.67-.469 1.579-.393 2.048.276l2.08 2.964c.278.804.202 1.713-.467 2.182"></path><path fill="url(#f)" d="M92.648 109.538 61.286 131.54c-.67.469-1.579.393-2.048-.276l-2.08-2.964c-.47-.669-.23-1.55.438-2.019l31.459-22.069c.67-.469 1.578-.394 2.048.276l2.08 2.964c.277.803.135 1.617-.535 2.086"></path><path fill="#F1F3F9" stroke="#D6DCE8" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.978" d="M93.834 60.76s-6.83-2.551-7.015-2.86c-.188-.172-1.912-1.66-3.017-2.604l.293-.544c.146-.272.292-.544.522-.84.138.003.305-.047.473-.097 2.22-.348 6.13.072 7.998 4.16z"></path><g filter="url(#g)"><path fill="url(#h)" d="m111.307 42.605-1.433 2.665c-.409.76-.785 1.33-1.383 1.92-1.855 2.017-4.535 2.959-7.182 2.797-.469-.041-.941.055-1.28.294-.393.21-.79.556-1.024.992a2.54 2.54 0 0 0 .169 2.684c1.887 2.487 2.454 5.736 1.343 8.714-.121.356-.296.682-.501 1.063l-1.433 2.664c-.175.327-.405.624-.551.896l-15.988-8.597c.092-.301.296-.682.443-.954l1.432-2.665c.147-.272.347-.514.493-.786.059-.109.201-.243.289-.406 1.897-2.485 4.836-3.779 7.868-3.55.937.083 1.865-.47 2.332-1.34.205-.38.33-.874.288-1.318.03-.054-.025-.083-.025-.083-.042-.443-.251-.836-.46-1.23-1.277-1.667-1.935-3.703-1.898-5.857.016-.552.032-1.104.187-1.652.004-.138.092-.301.15-.41.184-.602.397-1.259.718-1.857l1.433-2.665.146-.271 16.097 8.655c-.142.134-.171.188-.23.297"></path></g><path fill="#BAC3D1" d="M101.587 46.211 94.831 43l-2-2.407c.016-.552.033-1.104.187-1.652.004-.138.092-.301.15-.41 3.17.232 5.391.795 8.132 4.302.452.594.85 1.158 1.327 1.835 4.073 6.116-1.04 1.544-1.04 1.544"></path><path fill="#D5DDEA" d="M108.462 47.244c-1.855 2.017-4.535 2.96-7.183 2.798-.468-.042-.94.055-1.279.293l-.054-.029c-.87-.468-2.041-.116-2.509.754l-4.357 8.103-1.577-.848 4.386-8.157c.468-.87.17-2.012-.754-2.509-.042-.443-.251-.836-.46-1.229-1.277-1.668-1.935-3.704-1.898-5.858.016-.552.032-1.104.187-1.651 2.82 3.62 5.798 3.818 8.198 3.917.745.05 1.435.07 2.096.145 2.559.325 4.17 1.892 5.204 4.271"></path><path fill="#D5DDEA" d="m99.962 63.705-1.433 2.664c-.175.326-.405.624-.551.895l-14.248-7.66-1.068-2.187 1.287-2.393c.146-.272.292-.544.493-.786.058-.11.2-.243.288-.406.055.03.025.083.08.113.025.083.08.112.134.142 3.142 3.933 6.38 3.78 9.001 3.859.414.012.883.053 1.267.12 2.585.408 4.221 2.06 5.28 4.522-.204.38-.325.736-.53 1.117"></path><path fill="url(#i)" d="m111.939 43.646-17.837-9.591c-.38-.205-.531-.707-.356-1.033l.936-1.74c.205-.38.677-.477 1.058-.273l17.891 9.62c.381.205.561.653.356 1.034l-.906 1.685c-.314.322-.761.502-1.142.298"></path><path fill="url(#j)" d="M98.138 69.313 80.3 59.723c-.38-.205-.56-.653-.356-1.033l.906-1.686c.205-.38.677-.477 1.058-.273l17.891 9.62c.381.205.561.653.356 1.033l-.906 1.686c-.314.322-.732.448-1.112.243"></path><defs><linearGradient id="b" x1="65.646" x2="55.058" y1="11.417" y2="42.695" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFEFF"></stop><stop offset=".996" stop-color="#ECF0F5"></stop></linearGradient><linearGradient id="d" x1="43.511" x2="75.412" y1="72.866" y2="118.342" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFEFF"></stop><stop offset=".996" stop-color="#ECF0F5"></stop></linearGradient><linearGradient id="e" x1="26.49" x2="60.456" y1="84.614" y2="60.786" gradientUnits="userSpaceOnUse"><stop stop-color="#B0BACC"></stop><stop offset="1" stop-color="#969EAE"></stop></linearGradient><linearGradient id="f" x1="58.183" x2="92.149" y1="129.793" y2="105.966" gradientUnits="userSpaceOnUse"><stop stop-color="#B0BACC"></stop><stop offset="1" stop-color="#969EAE"></stop></linearGradient><linearGradient id="h" x1="103.795" x2="89.888" y1="37.399" y2="63.262" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFEFF"></stop><stop offset=".996" stop-color="#ECF0F5"></stop></linearGradient><linearGradient id="i" x1="94.205" x2="113.523" y1="32.148" y2="42.535" gradientUnits="userSpaceOnUse"><stop stop-color="#B0BACC"></stop><stop offset="1" stop-color="#969EAE"></stop></linearGradient><linearGradient id="j" x1="80.389" x2="99.707" y1="57.842" y2="68.23" gradientUnits="userSpaceOnUse"><stop stop-color="#B0BACC"></stop><stop offset="1" stop-color="#969EAE"></stop></linearGradient><filter id="a" width="75.947" height="75.947" x="22.326" y=".273" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix><feOffset dy="11"></feOffset><feGaussianBlur stdDeviation="11"></feGaussianBlur><feColorMatrix values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_567_21002"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_567_21002" result="shape"></feBlend></filter><filter id="c" width="103.063" height="107.772" x="8.082" y="52.95" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix><feOffset dy="11"></feOffset><feGaussianBlur stdDeviation="11"></feGaussianBlur><feColorMatrix values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_567_21002"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_567_21002" result="shape"></feBlend></filter><filter id="g" width="73.493" height="77.641" x="60.044" y="22.652" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix><feOffset dy="11"></feOffset><feGaussianBlur stdDeviation="11"></feGaussianBlur><feColorMatrix values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_567_21002"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_567_21002" result="shape"></feBlend></filter></defs></svg>
                                    </div>
                                    <div class="empty-text px-8">即将上线</div>-->
                                        <!--</div>-->
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="">
                            <div class="h-full w-96 bg-white flex flex-col  justify-between shadow-lg">
                                <div class="flex flex-col justify-between p-3">
                                    <div class="flex flex-col gap-4 ">
                                        <div class="pt-2">
                                            <div class="flex flex-col">
                                                <div class="">
                                                    <div class="outai relative border-b-2 border-blue-300 hover:border-b-4 hover:bg-gray-100 transition duration-200 ease-out
                                        rounded-lg">
                                                        <div class="flex gap-4 p-4">
                                                            <div class="flex items-center justify-center rounded-full w-10 h-10 bg-purple-600 text-white shadow-lg">
                                                                <i class="fa fa-pen-square" />
                                                            </div>
                                                            <div class="flex justify-center text-left">
                                                                <div>
                                                                    <div class="text-base font-bold mb-1">智能化咨询记录</div>
                                                                    <div class="text-gray-600">上传对话录音文件或在线录音</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="  innerai">
                                                            <div class="flex flex-col gap-3 p-4">
                                                                <button class="flex w-full bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200" @click="toggleUpLoad">
                                                                    <i class="far fa-file-alt text-2xl  p-4"></i>
                                                                    <div>
                                                                        <h5 class="font-bold  text-base text-left py-1">上传录音/对话稿文件</h5>
                                                                        <div class="text-gray-500  text-sm">上传来访对话录音或文本文件</div>
                                                                    </div>
                                                                </button>
                                                                <button @click="toogleRecord" class="flex items-center  w-full  bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200 rounded-lg ">
                                                                    <i class="far fa-file-alt text-2xl p-4"></i>
                                                                    <div>
                                                                        <h5 class="font-bold text-base text-left">在线录音</h5>
                                                                        <div class="text-gray-500  text-sm"></div>
                                                                    </div>
                                                                </button>
                                                                <!-- <button class="flex items-center  w-full bg-gray-200 text-gray-500 rounded-lg cursor-not-allowed" disabled>
                                                                <i class="far fa-file-alt text-2xl p-4"></i>
                                                                <div>
                                                                    <h5 class="font-bold text-base text-left">在腾讯会议中使用</h5>
                                                                    <div class="text-gray-500  text-sm">功能即将上线, 敬请期待!</div>
                                                                </div>
                                                            </button>-->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Other cards can be similarly converted -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex flex-col gap-4 " @click="toggleOverlay">
                                        <div class="pt-2">
                                            <div class="flex flex-col gap-2  ">
                                                <div class="py-2 ">
                                                    <div class="cursor-pointer border-b-2 border-blue-300 hover:border-b-4 hover:bg-gray-100  rounded-lg shadow-lg transition-transform transform hover:-translate-y-1 ">
                                                        <div class="flex items-start gap-4 p-3">
                                                            <div class="flex items-center justify-center rounded-full w-10 h-10 bg-green-400 text-white shadow-lg">
                                                                <i class="fa fa-file-alt"></i>
                                                            </div>
                                                            <div class="flex justify-center items-center text-left">
                                                                <div>
                                                                    <div class="text-base font-semibold mb-1 ">智能化心理测评</div>
                                                                    <div class="text-gray-600 text-sm">来访填写后将生成智能测评报告</div>
                                                                    <!--<div class="p-1 rounded absolute bottom-0 right-0 text-xs bg-gray-300 font-medium ">暂未上线</div>-->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex flex-col gap-4 " @click="gotoTrain">
                                        <div class="pt-2">
                                            <div class="flex flex-col gap-2  ">
                                                <div class="py-2 ">
                                                    <div class="cursor-pointer border-b-2 border-blue-300 hover:border-b-4 hover:bg-gray-100  rounded-lg shadow-lg transition-transform transform hover:-translate-y-1 ">
                                                        <div class="flex items-start gap-4 p-3">
                                                            <div class="flex items-center justify-center rounded-full w-10 h-10 bg-amber-500 text-white shadow-lg">
                                                                <i class="fa fa-user-friends text-base"></i>
                                                            </div>
                                                            <div class="flex justify-center items-center text-left">
                                                                <div>
                                                                    <div class="text-base font-semibold mb-1">AI来访训练室</div>
                                                                    <div class="text-gray-600 text-sm">多角色超拟人AI来访实时陪练并提供智能反馈报告</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--                                <div class="flex flex-col gap-4 " @click="showVisitImage">
                                    <div class="pt-2">
                                        <div class="flex flex-col gap-2  ">
                                            <div class="py-2 ">
                                                <div class="cursor-pointer border-b-2 border-blue-300 hover:border-b-4 hover:bg-gray-100  rounded-lg shadow-lg transition-transform transform hover:-translate-y-1 ">
                                                    <div class="flex items-start gap-4 p-3">
                                                        <div class="rounded bg-blue-100 w-12 h-12 flex items-center justify-center">
                                                            <img class="object-cover" src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/icon/sim.png" alt="AI共听">
                                                        </div>
                                                        <div class="flex justify-between w-full">
                                                            <div>
                                                                <h3 class="text-base font-semibold mb-1">AI来访</h3>
                                                                <div class="text-gray-600 text-sm">超多症状的超拟人AI来访实时在线</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <img v-if="isShowVisitImg" src="@/assets/sim.png" alt="示例图片"
                                         class="mt-1  rounded bg-blue-100 relative" />
                                </div>
                                <div class="flex flex-col gap-4">
                                    <div class="pt-2">
                                        <div class="flex flex-col gap-2  ">
                                            <div class="py-2 ">
                                                <div class="cursor-pointer border-b-2 border-blue-300 hover:border-b-4 hover:bg-gray-100  rounded-lg shadow-lg transition-transform transform hover:-translate-y-1 ">
                                                    <div class="flex items-start gap-4 p-3">
                                                        <div class="rounded bg-blue-100 w-12 h-12 flex items-center justify-center">
                                                            <img class="object-cover" src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/icon/supervise.png" alt="AI共听">
                                                        </div>
                                                        <div class="flex justify-between w-full">
                                                            <div>
                                                                <h3 class="text-base font-semibold mb-1">AI督导</h3>
                                                                <div class="text-gray-600 text-sm">多流派全能AI督导，24小时贴心在线</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>-->
                                </div>
                                <!--<div class="text-white rounded-lg p-4 ">
                                <div class="relative">
                                    <div class="flex items-center justify-center ">
                                        <img class="object-cover  rounded-lg" src="@/assets/banner02.WMAqj9J2.jpg" alt="Banner">
                                    </div>
                                    <div class="absolute left-0 right-0 bottom-0 flex justify-between">
                                        <button class="" aria-label="Carousel slide 1 of 1">
                                            <i class="i-tabler-circle text-white"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>-->
                            </div>
                        </div>
                    </main>

                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import axios from 'axios';
    import { jwtDecode } from 'jwt-decode';
    
    import { ref } from 'vue';
    import RecordModule from './RecordModule.vue'; 
    import ListenDialog from './subassembly/ListenDialog.vue'; 
    import QuestionDialog from './subassembly/QuestionDialog.vue'; 
    import CommonHeader from './subassembly/CommonHeader.vue';
    import AddVisitorDialog from './subassembly/AddVisitorDialog.vue';
    import { mapState, mapActions } from 'vuex'
    import CheckInfoDialog from './yuyue/modals/CheckInfoDialog.vue'

    export default {
        components: {
            RecordModule,
            ListenDialog,
            QuestionDialog,
            CommonHeader,
            AddVisitorDialog,
            CheckInfoDialog,
        },
        name: 'HomePage',
        metaInfo: {
            title: '识心智能 - 咨询师',
            meta: [
                {
                    name: 'description',
                    content: '识心智能官网，各行各业量身定制专属的智能心理健康解决方案，以AI科技的力量促进心理健康事业的创新与繁荣发展'
                },
                {
                    name: 'keywords',
                    content: '识心智能, 心理健康, 心理健康AI, 心理AI, 健康AI, 心理健康方案, 声音疗愈, 智慧校园, 校园心理, 咨询师AI助手'
                }
            ]
        },

        setup() {
            const formRef = ref(null);
            const form_addvisitor = ref({
                visitorName: '匿名',
                gender: '',
                age: '',
                visitDate: '',
                contact: '',
                backgroundInfo: '',
                symptoms:'',
                useLanguage: '普通话',
            });

            const rules = {
                visitorName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
                age: [
                    { required: true, message: '请输入年龄', trigger: 'blur' },
                    { pattern: /^[1-9][0-9]*$/, message: '年龄必须是正整数', trigger: 'blur' }
                ],
                visitDate: [{ required: true, message: '请选择首次访问时间', trigger: 'change' }]
            };

            const submitAddVisitorFormCheck = () => {
                var result;
                formRef.value.validate(valid => {
                    if (valid) {
                        result= true;
                    } else {
                        result=false;
                    }
                });
                return result;
            };

            return {
                formRef,
                form_addvisitor,
                rules,
                submitAddVisitorFormCheck,
            };
        },
        data() {
            return {
                appointments_total: 0,
                detailType: "",
                tempflag: false,
                checkFlag: false,
                checkTimer: null,
                selectedAppointment:null,
                interval_getAppoints:null,
                showAppointDetail: false,
                appointments: [
/*                    {
                        id: 's4',
                        name: '陈女士-示例',
                        organization: '',
                        phone: '136****6666',
                        email: 'chen@personal.com',
                        interest: 'home',
                        submit_time: '2025-06-19 09:00',
                        state: 'rejected',
                        resvType: "edu"
                    }
*/                ],
                isLoadingLock: false,
                topButtonList: [
                    { icon: 'https://unsplash.com/photos/N7XodRrbzS0', text: '智能化咨询记录' },
                    { icon: 'https://picsum.photos/60/60?random=2', text: '智能化心理测评' },
                    { icon: 'https://picsum.photos/60/60?random=3', text: 'AI来访训练室' },
                    { icon: 'https://picsum.photos/60/60?random=3', text: '来访管理' },
                ],
                mobileNavOpen: false,
                // activity
                listenObj: {
                    HasMore: false,
                    Curpage: 0,
                    ActivityList: [],
                    pageItemNum:0,
                },
                testObj: {
                    HasMore: false,
                    Curpage: 0,
                    ActivityList: [],
                    pageItemNum: 0,
                },
                trainList: {
                    HasMore: false,
                    Curpage: 0,
                    ActivityList: [],
                    pageItemNum: 0,
                },
                isRecordVisible: false,
                timeoutId:null,//防抖动
                searchVisitorKey:"",
                visitorTryTime:6,
                isLoggedInState: false,
                isUserMenuVisible: false,
                user: {},
                form: {
                    dialogFormVisible: false,
                    phone: '',
                    phonePrefix: '+86',
                    verificationCode: '',
                    nickname: '',
                    birthday: '',
                    gender: '',
                    invitationCode: '',
                    agreement: false,
                    phoneError: '',
                    verificationCodeError: '',
                    nicknameError: '',
                    agreementError: '',
                    isCountingDown: false,
                    countdown: 60,
                    verificationButtonText: '获取验证码'
                },
                loginForm: {
                    dialogFormVisible: false,
                    phonePrefix: '+86',
                    phone: '',
                    verificationCode: '',
                    phoneError: '',
                    verificationCodeError: '',
                    isCountingDown: false,
                    countdown: 60,
                    verificationButtonText: '获取验证码'
                },
                registrationMessage: '',
                loginMessage: '',
                dialogWidth: '30%',
                isShowVisitImg: false,
                pageSelect: 0,
                dyncSelect: 'all',
                evaluateSelect: "New",
                tabs: [
                    { value: 'all', label: '全部' },
                    { value: 'conclusion', label: '咨询报告' },
                    { value: 'evaluation', label: '测评报告' },
                    { value: 'train', label: '来访练习' },
                ],
                isGenBtnDisabled: false,
                activityList: [
                    {
                        type:"test",
                        tipinfo: "TIP: 其他功能示例都是以该模拟来访咨询内容作为背景",
                        activityTitle: "【测评报告】/咨询报告·xxx",
                        state: "已完成",
                        visitorName: "官方示例",
                        createTime: "09-16 00:00",
                        abstract: "咨询师表现出很强的共情能力和理解力，通过多次使用“拥抱”等情感回应，成功建立了一个支持性的谈话环境。咨询师倾听对方的烦恼，尤其是在谈到家庭背景和个人压力来源时展现了深刻的理解。例如，询问对方关于与母亲的关系时，能够深入探讨对方的情感体验，为建立信任打下基础。",
                    }
                ],
                isOverlayVisible: false, // 控制覆盖层的显示状态
                isShowUploadFile: false,
                isShowMoudle: false,
                showloading: false,
                activeName: "second",
                isVisitorVisible: false,
                isVisitorListVisible: false,
                visitorList: [
                    {
                        index: "S",
                        vinfos: [
                            {
                                vid: "0",
                                visitorName: "识心",
                                gender: '男',
                                age: "18",
                                createdAt: "2025-02-15T15:01:26.000Z",
                                backgroundInfo: "第一次来",
                                color: `rgba(201, 139, 134, 0.3)` ,
                            }
                        ]
                    },                 
                ],
                freshState: 'idle', // 'idle'|'loading'|'error'|'complete'
                visitorShowList:[],
                testClassifyList: ["New"],
                moduleDetailInfo:"",
                
                fileList: [],
                errorMessage: '',
                maxFileSize: 2 * 1024 * 1024, // 2MB
                allowedFileTypes: ['image/jpeg', 'image/png'], 
                tableData: [],
                selectedEditionIndex: 0,
                activityCurPage: 0,
                activityAllPage: 0,
            };
        },
        mounted() {
            this.updateDialogWidth();
            window.addEventListener('resize', this.updateDialogWidth);
        },
        computed: {
            filteredEditionList() {
                return this.editionList.slice(0, 3);
            },
            allColors() {
                return this.visitorShowList.reduce((acc, visitor) => {
                    const color = visitor.vinfos.map(vinfo => vinfo.color);
                    return acc.concat(color);
                }, []);
            },
            allNames() {
                return this.visitorShowList.reduce((acc, visitor) => {
                    const names = visitor.vinfos.map(vinfo => vinfo.visitorName);
                    return acc.concat(names);
                }, []);
            },
            ...mapState({
                globalCharacters: state => state.globalCharacters,
                globalScales: state => state.globalScales,
            }),
            globalAppointments() {
                return this.$store.getters.getGlobalAppointments;
            },
            newAppointments() {
                if (!this.appointments || !Array.isArray(this.appointments)) {
                    return 0;
                }
                /*const today = new Date();
                const todayStr = today.toISOString().split('T')[0];
                
                const todayAppointments = this.appointments.filter(appointment => {
                    if (!appointment.submit_time) return false;
                    
                    const appointmentDate = appointment.submit_time.split(' ')[0];
                    return appointmentDate === todayStr;
                });*/
                return this.appointments.length;
            }
        },
        watch: {
            globalAppointments(newVal) {
                if (newVal) {
                    this.appointments = newVal;
                }
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateDialogWidth);
        },
        methods: {
            ...mapActions(['fetchGlobalCharacters', "fetchGlobalScales"]),
            async getAppointList() {
                const token = localStorage.getItem('token');
                
                if (!this.checkFlag && token) {
                    try {
                        const decodedToken = jwtDecode(token);
                        this.checkFlag = true;
                        if (decodedToken && decodedToken.user_id) {
                            console.log("de userid ", decodedToken.user_id);
                            if ([17, 6, 23].indexOf(decodedToken.user_id) != -1) {
                                this.tempflag = true;
                                this.$store.dispatch('stopAppointmentPolling');
                                this.checkTimer = setTimeout(() => {
                                    this.$store.dispatch('startAppointmentPolling');
                                    const globalAppointments = this.$store.getters.getGlobalAppointments;
                                    if (globalAppointments) {
                                        this.appointments = globalAppointments;
                                    }
                                }, 1000);
                            } else {
                                return;
                            }
                        }
                    } catch (error) {
                        console.error(' failed:', error);
                    }
                }
                if (!token) {
                    this.checkFlag = false;
                    this.tempflag = false;
                }
                console.log("this.tempflag ", this.tempflag);
                if (!this.tempflag) {
                    return;
                }
                const isInExpired = await this.$store.dispatch('isInExpired');
                if (!isInExpired) {
                    this.$message({
                        message: "登录已过期，请重新登录",
                        type: "error",
                    });
                    return;
                }
                this.freshState = 'loading';
                try {
                    const payload = {
                        curpage: 1,
                    };
                    const response = await axios.post('/api/reservation/undo-list', payload, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    if (response.status !== 200) {
                        this.$message({
                            message: "网络异常，请稍后尝试",
                            type: "error",
                        });
                        console.error(response.status);
                        this.freshState = 'error';
                        return;
                    }
                    if (response.data.code !== "00") {
                        this.$message({
                            message: response.data.message,
                            type: "error",
                        });
                        console.error(response.status);
                        this.freshState = 'error';
                    }
                    this.appointments = response.data.infos;
                    //this.totalItems = response.data.total;
                    this.freshState = 'complete';
                } catch (error) {
                    console.error(' failed:', error);
                    this.$message({
                        message: "网络异常，请稍后尝试",
                        type: "error",
                    });
                    this.freshState = 'error';
                }
            },
            gotoPlatform() {
                this.$router.push({ name: 'ReservationView' });
            },
            appointmentClick(index) {
                this.selectedAppointment = this.appointments[index];
                this.detailType = this.selectedAppointment.resvType;
                this.showAppointDetail = true;
            },
            getInterestStr(item) {
                const intest = item.intest;

                if (!intest || intest.length == 0) {
                    return "";
                }
                let interestMap = {};

                const intestList = intest.split(",");
                if (intest.resvType == "edu") {
                    interestMap = {
                        'teacher': '教师功能',
                        'student': '学生功能',
                        'parent': '家长功能',
                        'all': '全部功能'
                    };
                } else {
                    interestMap = {
                        'other': '其他场景',
                        'personal': '个人家庭',
                        'hotel': '高端酒店',
                        'medical': '医疗辅助',
                        'company': '企业健康',
                        'all': '所有场景'
                    };
                }
                const translatedList = intestList.map(item => {
                    const trimmedItem = item.trim();
                    return interestMap[trimmedItem] || trimmedItem;
                });

                return translatedList.join("  ") || intest;
            },
            listenUpdateSuccess() {
                this.freshState = 'idle';
                this.initDyncParams();
                this.trainList = {
                    HasMore: false,
                    Curpage: 0,
                    ActivityList: [],
                    pageItemNum: 0,
                };

                this.activityList.splice(0, this.activityList.length);
                this.getMainDync();
            },
            async fetchCharacters() {
                await this.fetchGlobalCharacters();
            },
            addVisitorConfirm() {
                this.getAllVisitors();
            },
            async fetchScales() {
                await this.fetchGlobalScales();
            },
            async retryLoading() {
                if (this.isLoadingLock) return;
                this.isLoadingLock = true;
                this.freshState = 'loading';
                try {
                    switch (this.dyncSelect) {
                        case this.tabs[0].value://all
                            console.log("-------[0]tsetx-----");
                            console.log(this.testObj.HasMore);
                            console.log(this.testObj.pageItemNum);
                            console.log(this.testObj.Curpage);
                            console.log("-------listen-----");
                            console.log(this.listenObj.HasMore);
                            console.log(this.listenObj.pageItemNum);
                            console.log(this.listenObj.Curpage);
                            console.log("-------train-----");
                            console.log(this.trainList.HasMore);
                            console.log(this.trainList.pageItemNum);
                            console.log(this.trainList.Curpage);

                            if (!this.listenObj.HasMore && !this.testObj.HasMore && !this.trainList.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            if (this.testObj.pageItemNum && this.testObj.HasMore) {
                                this.testObj.Curpage++;
                            }
                            if (this.trainList.pageItemNum && this.trainList.HasMore) {
                                this.trainList.Curpage++;
                            }
                            if (this.listenObj.pageItemNum && this.listenObj.HasMore) {
                                this.listenObj.Curpage++;
                            }
                            break;
                        case this.tabs[1].value:
                            //this.listenObj.Curpage++;
                            console.log("-------[1]-----");
                            console.log(this.listenObj.HasMore);
                            console.log(this.listenObj.pageItemNum);
                            console.log(this.listenObj.Curpage);
                            if (!this.listenObj.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            if (this.listenObj.pageItemNum && this.listenObj.HasMore) {
                                this.listenObj.Curpage++;
                            }
                            break;
                        case this.tabs[2].value:
                            //this.testObj.Curpage++;
                            console.log("-------[2]-----");
                            console.log(this.testObj.HasMore);
                            console.log(this.testObj.pageItemNum);
                            console.log(this.testObj.Curpage);
                            if (!this.testObj.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            if (this.testObj.pageItemNum && this.testObj.HasMore) {
                                this.testObj.Curpage++;
                            }
                            
                            break;
                        case this.tabs[3].value:
                            console.log("-------[3]-----");
                            console.log(this.trainList.HasMore);
                            console.log(this.trainList.pageItemNum);
                            console.log(this.trainList.Curpage);
                            //this.trainList.Curpage++;
                            if (!this.trainList.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            if (this.trainList.pageItemNum && this.trainList.HasMore) {
                                this.trainList.Curpage++;
                            }
                            break;
                    }
                    await this.getMainDync();
                    switch (this.dyncSelect) {
                        case this.tabs[0].value://all
                            console.log("-------[4]-----");
                            console.log(this.trainList.HasMore);
                            console.log(this.listenObj.HasMore);
                            console.log(this.testObj.HasMore);

                            if (!this.listenObj.HasMore && !this.testObj.HasMore && !this.trainList.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            break;
                        case this.tabs[1].value:
                            if (!this.listenObj.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            break;
                        case this.tabs[2].value:
                            if (!this.testObj.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            break;
                        case this.tabs[3].value:
                            if (!this.trainList.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            break;
                    }
                } catch (error) {
                    this.freshState = 'error';
                }
                finally {
                    this.isLoadingLock = false;
                }
            },
            handleScroll() {
                if (this.freshState !== 'idle') return;

                const container = this.$refs.act_container;
                const threshold = 20;

                if (container.scrollTop + container.clientHeight >= container.scrollHeight - threshold) {
                    this.retryLoading();
                }
            },
            getMapState(staStr) {
                switch (staStr) {
                    case "create":
                        return '未处理';
                    case "contacted":
                        return '已联系';
                    case "rejected":
                        return '已拒绝';
                    default:
                        return '';
                }

            },
            getMapColor(staStr) {
                switch (staStr) {
                    case "create":
                        return 'bg-green-100 text-green-600';
                    case "contacted":
                        return 'bg-teal-100 text-teal-600';
                    case "rejected":
                        return 'bg-red-100 text-red-600';
                    case "进行中":
                        return 'bg-green-100 text-green-600';
                    case "处理中":
                        return 'bg-yellow-100 text-yellow-600';
                    case "阶段完成":
                        return 'bg-blue-100 text-blue-600';
                    case "转换中":
                        return 'bg-purple-100 text-purple-600';
                    case "已完成":
                        return 'bg-teal-100 text-teal-600';
                    case "异常":
                        return 'bg-red-100 text-red-600';
                    default:
                        return 'bg-gray-100 text-gray-800';
                }
            },
            getStatusMapping(staStr) {
                const stalist = ["create", "inProcess", "stageFinish", "modelProcess", "finish", "error", "success"];
                const maplist = {
                    "create": "进行中",
                    "inProcess": "处理中",
                    "stageFinish": "作答完成",
                    "modelProcess": "转换中",
                    "finish": "已完成",
                    "success": "已完成",
                    "error": "异常",
                    "unkonow": "未知"
                }
                
                if (stalist.includes(staStr)){
                    return maplist[staStr];
                } else {
                    return maplist["unkonow"];
                }
            },
            handleAddVisitor() {
                this.isVisitorListVisible = false;
                this.isVisitorVisible = true;
            },
            activityClick(index) {
                this.activityCurPage = index;
                console.log("clck" + index);
                var cur = this.activityList[this.activityCurPage]
                if (cur.state == "进行中") {
                    this.$message.info({ message: '请稍等，正在生成中...', duration: 3000 });
                } else {
                    if (cur.type == "test") {
                        localStorage.setItem("router", btoa(JSON.stringify({ id: cur.taskid, type: cur.type })));
                        this.$router.push({ name: 'QuestionResult' });
                    } else if (cur.type == "train") {
                        localStorage.setItem("router", btoa(JSON.stringify({ id: cur.taskid, type: cur.type,userid:"user_"+cur.cid})));
                        this.$router.push({ name: 'TrainDetail' });//TODO
                    } else {
                        localStorage.setItem("router", btoa(JSON.stringify({ id: cur.taskid, type: cur.type })));
                        this.$router.push({ name: 'ConclusionM' });
                    }
                }
            },
            gotoTrain() {
				//TODO
               /* const token = localStorage.getItem('token');
                if (!token) {
                    this.$message.error('请先登录！ ');
                    setTimeout(() => {
                        this.showLogin();
                    }, 2000);
                    return;
                }*/
                this.$router.push({ name: 'SkillTraining' });
            },
            selectEdition(index) {
                this.editionDetailId=index;
                this.selectedEditionIndex = index; // 更新选中的版本
            },
            handleSearchVisitor() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.visitorFilter();
                }, 1000); 
            },
            visitorFilter() {
                if (this.searchVisitorKey.trim() === '') {
                    this.visitorShowList = this.visitorList;
                } else {
                    this.visitorShowList = this.visitorList.map(visitor => {
                        return {
                            index: visitor.index,
                            vinfos: visitor.vinfos.filter(v => v.visitorName.includes(this.searchVisitorKey)) 
                        };
                    }).filter(visitor => visitor.vinfos.length > 0); 
                }
            },
            handleSelectVisitorChange(value) {
                var v ;
                this.visitorList.forEach(group => {
                    // 筛选当前组中的 vinfos
                    const matchingVinfos = group.vinfos.filter(vinfo => vinfo.visitorName === value);                    
                    if (matchingVinfos.length >0) {
                        v = matchingVinfos[0];
                        console.log("====选择匹配========");
                        console.log(v);
                    }
                });
                this.form_addvisitor.visitorName = v.visitorName;
                this.form_addvisitor.age = v.age;
                this.form_addvisitor.gender = v.gender;
                this.form_addvisitor.backgroundInfo = v.backgroundInfo;
                this.form_addvisitor.symptoms = v.symptoms;
                this.form_addvisitor.contact = v.contact;
            },
            addVisitorClose() {
                this.form_addvisitor = {
                    visitorName: '匿名',
                    gender: '',
                    age: '',
                    visitDate: '',
                    contact: '',
                    symptoms:'',
                    backgroundInfo: '',
                    useLanguage: '普通话',
                };      
            },
            getRandomColor() {
                // 生成较淡的随机颜色
                const r = Math.floor(Math.random() * 120); // 红色值
                const g = Math.floor(Math.random() * 120); // 绿色值
                const b = Math.floor(Math.random() * 120); // 蓝色值

                // 计算平均值以生成浅色
                const lightColor = `rgba(${Math.floor(r + 128)}, ${Math.floor(g + 128)}, ${Math.floor(b + 128)}, 0.4)`;
                return lightColor;
            },
            ///
            mapObj2ActList(itemList) {
                if (itemList.length > 0) {
                    for (var item of itemList) {
                        var visitorName = "·";
                        if (item.vname) {
                            visitorName = visitorName+item.vname;
                        }
                        console.log(item);
                        var obj = {
                            type:"test",
                            tipinfo: "测评报告" + visitorName,
                            activityTitle: item["Name"],
                            state: this.getStatusMapping(item.state),
                            visitorName: item.vname ? item.vname:"无归属",
                            createTime: item.createTime.slice(5, 16),
                            fulltime: item.createTime,
                            abstract: item["Introduction"],
                            taskid:item.id//todo 暂时使用id
                        };
                        this.activityList.push(obj);
                    }
                }
            },
            freshGetList(freshType) {
                switch (freshType) {
                    case "all":
                        break;
                    case "visitors":
                        this.getAllVisitors();
                        break;
                    default:
                        break;
                }
            },            
            mapScaleToList(scales, showList) {
                const scaleMap = {};
                scales.forEach(scale => {
                scaleMap[scale._id] = {
                    "Name": scale["Name"],
                    "Introduction": scale["Introduction"],
                    "English_name": scale["English_name"]};
                });
  
                return showList.map(item => {
                const match = scaleMap[item.questionId];
                if (match) {
                    return { ...item, ...match, }
                }else{
                    return { ...item, "Name": "无法对应","Introduction":"无"}
                }
                });
            },
          
            async submitAddVisitorForm() {
                if (!this.submitAddVisitorFormCheck()) {
                    return;
                }
                const token = localStorage.getItem('token');
                if (!token) {
                    this.$message.error('请先登录！ ');
                    setTimeout(() => {
                        this.showLogin();
                    }, 2000);
                    return; 
                }
                try {
                    const payload = {
                        name: this.form_addvisitor.visitorName,
                        age: this.form_addvisitor.age,
                        gender: this.form_addvisitor.gender,
                        visitDate: this.form_addvisitor.visitDate,
                        contact: this.form_addvisitor.contact,
                        symptoms: this.form_addvisitor.symptoms,
                        backgroundInfo: this.form_addvisitor.backgroundInfo,
                    };

                    const response = await axios.post('/api/visitor/add', payload, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    this.$message({
                        message: response.data.message,
                        type: response.data.type
                    });
                    this.isVisitorVisible = false;
                    this.freshGetList("visitors");
                } catch (error) {
                    console.error('add failed:', error);
                    this.registrationMessage = 'add visitor failed. Please try again.';
                }
            },
            closeDialog() {
                this.isVisitorVisible = false;
            },
            isActive(name) {
                return this.$refs.tabs.activeName === name;
            },
            loading(times) {
                this.showloading = true;
                setTimeout(() => {
                    this.showloading = false;
                }, times*1000);
            },
            toggleUpLoad() {
                this.isShowUploadFile = !this.isShowUploadFile; // 切换覆盖层状态
                if (!this.isShowUploadFile) {
                    this.fileList.splice(0, this.fileList.length);
                    this.selectedEditionIndex = 0;
                    this.editionDetailId = 0;
                }
                this.addVisitorClose();
            },
            toogleRecord() {
                this.isRecordVisible = !this.isRecordVisible;
            },
            toggleOverlay() {
                this.isOverlayVisible = !this.isOverlayVisible; // 切换覆盖层状态
                if (this.isOverlayVisible) {
                    this.loading(2);
                }
            },
            showVisitImage() {
                this.isShowVisitImg = !this.isShowVisitImg; 
            },
            setTestCaseSelect(selectedCase) {
                if (selectedCase == this.testCaseSelect) {
                    return;
                }
                for (const item of this.testList) {  
                    console.log(item.title, selectedCase.title);
                    if (item == selectedCase) {
                        this.testCaseSelect = selectedCase;
                        break;
                    }
                }
            },
            setEvalBtnSelect(selectedBtn) {
                if (selectedBtn == this.evaluateSelect) {
                    return;
                }
                for (const item of this.testClassifyList) {
                    console.log(selectedBtn, item, selectedBtn == item);
                    if (item == selectedBtn) {
                        this.evaluateSelect = selectedBtn;
                        //TODO req
                        break;
                    }
                }
            },
            setPage(selectedPage) {
                if (selectedPage == this.dyncSelect) {
                    return;
                }
                this.activityList.splice(0, this.activityList.length);
                for (const item of this.tabs) {
                    if (item.value == selectedPage) {
                        this.dyncSelect = selectedPage;
                        this.getMainDync();
                        break;
                    }
                }
            },
            isActiveSubPage(pageValue) {
                return this.page === pageValue;
            },
            setActiveTab(tab) {
                if (this.pageSelect == tab) {
                    return;
                }
                if (tab == 1) {
                    if (this.appointments && (this.appointments.length ==0 || !this.interval_getAppoints || Date.now() - this.interval_getAppoints > 60 * 3 * 1000)) {
                        this.getAppointList();
                        this.interval_getAppoints = Date.now();
                    }
                }
                
                this.pageSelect = tab;
            },
            gotoHome() {
                this.$router.push({ name: 'HomePage' });
            },
            gotoVisitor(visitor) {
                const vjsonStr = JSON.stringify(visitor);
                this.$router.push({ name: 'Visitor', params: { visitorInfo: encodeURIComponent(vjsonStr),cid:this.user.id} });
            },
            gotoNewsInfo() {
                this.$router.push({ name: 'NewsInfo' });
            },
            gotoTeacherAI() {
                this.$router.push({ name: 'TeacherAI' });
            },
            scrollToSection(sectionId) {
                this.$router.scrollTo({
                    el: `#${sectionId}`,
                    behavior: 'smooth'
                });
            },
            updateDialogWidth() {
                if (window.innerWidth <= 1000) {
                    this.dialogWidth = '90%';
                } else {
                    this.dialogWidth = '30%';
                }
            },
            isLoggedIn() {
                return !!localStorage.getItem('token');
            },
            showUserMenu() {
                this.isUserMenuVisible = true;
            },
            hideUserMenu() {
                this.isUserMenuVisible = false;
            },
            showRegister() {
                this.loginForm.dialogFormVisible = false;
                this.form.dialogFormVisible = true;
            },
            showLogin() {
                this.form.dialogFormVisible = false;
                this.loginForm.dialogFormVisible = true;
            },
            logout() {
                localStorage.removeItem('token');
                this.tempflag = false;
                this.checkFlag = false;
                this.user = {};
                this.isLoggedInState = false;
                this.$message({
                    message: '登出成功',
                    type: 'success'
                });
            },
            validatePhone() {
                const phoneRegex = /^[0-9]{11}$/;
                if (!phoneRegex.test(this.form.phone)) {
                    this.form.phoneError = '请输入有效的11位手机号';
                } else {
                    this.form.phoneError = '';
                }
            },
            validateVerificationCode() {
                if (!this.form.verificationCode) {
                    this.form.verificationCodeError = '验证码不能为空';
                } else if (!/^[0-9]{6}$/.test(this.form.verificationCode)) {
                    this.form.verificationCodeError = '请输入6位数字验证码';
                } else {
                    this.form.verificationCodeError = '';
                }
            },
            validateNickname() {
                if (!this.form.nickname) {
                    this.form.nicknameError = '昵称不能为空';
                } else if (this.form.nickname.length > 20) {
                    this.form.nicknameError = '昵称长度不能超过20个字符';
                } else {
                    this.form.nicknameError = '';
                }
            },
            validateAgreement() {
                if (!this.form.agreement) {
                    this.form.agreementError = '请阅读并同意用户协议和隐私政策';
                } else {
                    this.form.agreementError = '';
                }
            },
            saveAuthData(response) {
                // 保存 token 和用户信息到 localStorage
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token);
                }
            },
            async submitForm() {
                this.validatePhone();
                this.validateVerificationCode();
                this.validateNickname();
                this.validateAgreement();

                if (this.form.phoneError || this.form.verificationCodeError || this.form.nicknameError || this.form.agreementError) {
                    return;
                }

                try {
                    const payload = {
                        phone: this.form.phone,
                        nickname: this.form.nickname,
                        birthday: this.form.birthday,
                        gender: this.form.gender,
                        verificationCode: this.form.verificationCode
                    };
                    const response = await axios.post('/api/register', payload, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    this.$message({
                        message: response.data.message,
                        type: response.data.type
                    });
                    this.registrationMessage = response.data.message;
                    this.form.dialogFormVisible = false;
                    if (response.data.token) {
                        this.saveAuthData(response);
                        // 查询用户信息
                        await this.checkTokenAndFetchUserInfo();
                        this.visitorTryTime=6;
                        await this.getAllVisitors();
                    }
                } catch (error) {
                    console.error('Registration failed:', error);
                    this.registrationMessage = 'Registration failed. Please try again.';
                }
            },
            validateLoginPhone() {
                const phoneRegex = /^[0-9]{11}$/;
                if (!phoneRegex.test(this.loginForm.phone)) {
                    this.loginForm.phoneError = '请输入有效的11位手机号';
                } else {
                    this.loginForm.phoneError = '';
                }
            },
            validateLoginVerificationCode() {
                if (!this.loginForm.verificationCode) {
                    this.loginForm.verificationCodeError = '验证码不能为空';
                } else if (!/^[0-9]{6}$/.test(this.loginForm.verificationCode)) {
                    this.loginForm.verificationCodeError = '请输入6位数字验证码';
                } else {
                    this.loginForm.verificationCodeError = '';
                }
            },
            assignColors() {
                this.visitorList.forEach(visitorGroup => {
                    visitorGroup.vinfos.forEach(visitor => {
                        if (!visitor.color) {
                            visitor.color = this.getRandomColor();
                        }
                    });
                });
            },
            async getAllVisitors(){
                /*if(!this.isLoggedInState){
                    return ;
                } todo 临时屏蔽*/
                const token = localStorage.getItem('token');
                console.log("getAllVisitors token "+token);
                if (!token) {
                    return;
                }
                try {
                    const response = await axios.get('/api/getvisitors',  {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    if(response.data.code == "00"){
                        console.log('Login successful:', response.data);
                        if (response.data.visitorList.length > 0) {
                            this.visitorList = response.data.visitorList;
                            console.log(this.visitorShowList);
                            this.assignColors();
                            this.visitorFilter();
                        }
                    }else{                        
                        this.$message({
                            message: response.data.message,
                            type: response.data.type,                        
                        });
                    }
                    
                } catch (error) {
                    console.error('get visitors error:', error);
                    if(this.visitorTryTime > 0){
                        this.visitorTryTime-=1;
                    }                    
                    /*setTimeout(() => {
                       this.getAllVisitors(); 
                    }, 4*1000);*/
                }
            },
            initDyncParams() {
                this.listenObj = {
                    HasMore: false,
                    Curpage: 0,
                    ActivityList: [],
                    pageItemNum: 0,
                };
                this.testObj = {
                    HasMore: false,
                    Curpage: 0,
                    ActivityList: [],
                    pageItemNum: 0,
                };
            },
            timestamp2YY(timestamp) {
                const date = new Date(timestamp);
                const year = String(date.getFullYear()).slice(-2);
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            },
            handleTalk2Activity(talkList, characters) {
                for (var talk of talkList) {
                    const curCharacter = characters.find(char => char.client_ID ===talk.client_id)
                    const vname = curCharacter.name;
                    var obj = {
                        type: "train",
                        activityTitle: `${vname}训练记录`,
                        taskid: talk.conversation_id,
                        //tipinfo: `${talk.trainType}·`,
                        tipinfo: `${vname}·`,
                        state: talk.summary_path ? this.getStatusMapping("finish") :this.getStatusMapping("inProcess"),
                        createTime: this.timestamp2YY(talk.startTime), 
                        fulltime: "20"+this.timestamp2YY(talk.startTime),
                        visitorName: vname,
                        cid: talk.cid,
                        abstract: curCharacter.description,
                    }
                    this.activityList.push(obj);
                }
            },
            handleActivityList(info, infolist) {
                for (let i = 0; i < infolist.length; i++) {
                    console.log("==listen===");
                    console.log(infolist[i].status);
                    var obj = {
                        type: "listen",
                        tipinfo: `咨询记录·${infolist[i].edition}·${infolist[i].file_name}`,
                        activityTitle: infolist[i].file_name,
                        state: this.getStatusMapping(infolist[i].status),
                        visitorName: infolist[i].vname,
                        createTime: infolist[i].created_at.slice(5, 16),
                        fulltime: infolist[i].created_at,
                        //abstract: "咨询师表现出很强的共情能力和理解力",
                        abstract: `${infolist[i].created_at.slice(5, 16)} 咨询记录`,
                        taskid: infolist[i]["taskid"],
                    }
                    this.activityList.push(obj);
                }
                console.log(this.activityList);
            },

            async getListenInfos() {   
                /*if(!this.isLoggedInState){
                    return ;
                }*/
                try {
                    const token = localStorage.getItem('token');
                    if (!token) {
                        return;
                    }
                    const response = await axios.get(`/api/listen/list?page=${this.listenObj.Curpage}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    if (response.data.code == "00") {
                        console.log('successful:', response.data);
                        if (response.data.info) {
                            this.listenObj.pageItemNum = response.data.info.count;
                            this.listenObj.HasMore = response.data.info.hasMore;
                        }
                        this.handleActivityList(response.data.info, response.data.infoList)
                    } else {
                        this.$message({
                            message: response.data.message,
                            type: response.data.type,
                        });
                        this.freshState = 'error';
                    }

                } catch (error) {
                    console.error('get visitors error:', error);
                    if (this.visitorTryTime > 0) {
                        this.visitorTryTime -= 1;
                    }
                    this.freshState = 'error';
                    /*setTimeout(() => {
                       this.getAllVisitors(); 
                    }, 4*1000);*/
                }
            },
            async submitLoginForm() {
                this.validateLoginPhone();
                this.validateLoginVerificationCode();

                if (this.loginForm.phoneError || this.loginForm.verificationCodeError) {
                    return;
                }

                try {
                    const payload = {
                        phone: this.loginForm.phone,
                        verificationCode: this.loginForm.verificationCode
                    };
                    const response = await axios.post('/api/login', payload, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    this.$message({
                        message: response.data.message,
                        type: response.data.type
                    });
                    console.log('Login successful:', response.data);
                    this.loginMessage = response.data.message;
                    this.loginForm.dialogFormVisible = false;
                    if (response.data.token) {
                        this.saveAuthData(response);
                        // 查询用户信息
                        await this.checkTokenAndFetchUserInfo();
                        this.visitorTryTime=6;
                        await this.getAllVisitors();
                    }
                    if (["18201623860", "13661126580", "13466847260"].indexOf(this.loginForm.phone) != -1) {
                        this.checkFlag = true;
                        this.tempflag = true;
                        this.checkTimer = setTimeout(() => {
                            this.$store.dispatch('startAppointmentPolling');
                            const globalAppointments = this.$store.getters.getGlobalAppointments;
                            if (globalAppointments) {
                                this.appointments = globalAppointments;
                            }
                        }, 1000);
                    }
                } catch (error) {
                    console.error('Login failed:', error);
                    this.loginMessage = 'Login failed. Please try again.';
                }
            },
            async getVerificationCode(formType) {
                const form = this[formType];
                this.validatePhone();
                if (form.phoneError) {
                    this.$message({
                        message: form.phoneError,
                        type: 'error'
                    });
                    return;
                }

                try {
                    const response = await axios.post('/api/get_verification_code', {
                        phone: form.phone,
                        type: formType === 'form' ? 'register' : 'login'
                    }, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    console.log('Verification code sent:', response.data);
                    this.$message({
                        message: response.data.message,
                        type: response.data.type
                    });
                    this.startCountdown(formType);
                } catch (error) {
                    console.error('Failed to get verification code:', error);
                    this.$message({
                        message: '获取验证码失败，请重试',
                        type: 'error'
                    });
                }
            },
            startCountdown(formType) {
                const form = this[formType];
                form.isCountingDown = true;
                form.countdown = 60;
                form.verificationButtonText = `${form.countdown}s`;
                const interval = setInterval(() => {
                    form.countdown -= 1;
                    if (form.countdown > 0) {
                        form.verificationButtonText = `${form.countdown}s`;
                    } else {
                        clearInterval(interval);
                        form.verificationButtonText = '获取验证码';
                        form.isCountingDown = false;
                    }
                }, 1000);
            },
            async checkTokenAndFetchUserInfo() {
                const token = localStorage.getItem('token');
                if (token) {
                    try {
                        const decodedToken = jwtDecode(token);
                        const currentTime = Date.now() / 1000; // 当前时间的秒数
                        // const expDate = new Date(decodedToken.exp * 1000).toLocaleString();
                        // const currentDate = new Date(currentTime * 1000).toLocaleString();
                        // console.log('Token decoded.exp:', expDate, 'currentTime:', currentDate);
                        if (decodedToken && decodedToken.user_id) {
                            console.log("de userid ", decodedToken.user_id);
                            if ([17, 6, 23].indexOf(decodedToken.user_id) != -1) {
                                this.tempflag = true;
                                this.$store.dispatch('stopAppointmentPolling');
                                this.checkTimer = setTimeout(() => {
                                    this.$store.dispatch('startAppointmentPolling');
                                    const globalAppointments = this.$store.getters.getGlobalAppointments;
                                    if (globalAppointments) {
                                        this.appointments = globalAppointments;
                                    }
                                }, 1000);
                            } else {
                                return;
                            }
                        }
                        if (decodedToken.exp > currentTime) {
                            // Token 未过期，查询用户信息
                            const response = await axios.get(`/api/users/${decodedToken.user_id}`, {
                                headers: {
                                    'Authorization': `Bearer ${token}`
                                }
                            });
                            this.user = response.data;
                            this.isLoggedInState = true;
                        } else {
                            // Token 已过期，清除本地存储
                            localStorage.removeItem('token');
                        }
                    } catch (error) {
                        console.error('Token 解析失败或用户信息查询失败:', error);
                        localStorage.removeItem('token');
                    }
                }
            },
            async updateToken() {
                const token = localStorage.getItem('token');
                if (token) {
                    try {
                        const response = await axios.post('/api/refresh_token', {}, {
                            headers: {
                                'Authorization': `Bearer ${token}`
                            }
                        });
                        const newToken = response.data.token;
                        localStorage.setItem('token', newToken);
                    } catch (error) {
                        console.error('Failed to update token:', error);
                    }
                }
            },
            async genQuestionnaireList() {
                const token = localStorage.getItem('token');
                console.log(token);
                if (!token) {
                    return;
                }
                try {
                    //this.getAllScales();
                    await this.fetchScales(); 
                } catch (error) {
                    this.$message.error("获取数据失败，请稍后重试！");
                    console.log("get scales error");
                    console.log(error);
                    return;
                }
                try {
                    const response = await axios.get("/api/questionnaire/list", {
                        params: {
                            page: this.testObj.Curpage,
                        },
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    console.log("=====questionnaire/list=====");
                    console.log(response.data.code);

                    if (response.status == 200 && response.data.code == "00") {
                        if (response.data.allCnt == 0) {
                            console.log("allCnt=0");
                            return;
                        }
                        console.log("=====questionnaire/list=====");
                        console.log(response.data);
                        this.testObj.HasMore = response.data.hasMore;
                        this.testObj.Curpage = response.data.curPage;

                        console.log("this.testObj.Curpage");
                        console.log(this.testObj.Curpage);
                        this.testObj.ActivityList = response.data.itemList;
                        this.testObj.pageItemNum = response.data.allCnt;
                       
                    } else {
                        this.$message.error("生成失败，请稍后重试！");
                        this.freshState = 'error';
                    }
                } catch (error) {
                    this.freshState = 'error';
                    //this.$message.error("生成失败，请稍后重试！");
                }
                console.log(this.globalScales);
                this.testObj.ActivityList = this.mapScaleToList(this.globalScales,this.testObj.ActivityList);
                this.mapObj2ActList(this.testObj.ActivityList);
            },
            async getHistoryTalk() {
                const token = localStorage.getItem('token');
                if (!token) { return; }
                try {
                    const response = await axios({
                        method: 'get',
                        url: `/api/train/history?page=${this.trainList.Curpage}`,
                        //url: "/api/train/history?page=0",
                        headers: {
                            'accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                    });
                    console.log(response);
                    if (response.status !== 200) {
                        console.error('Failed to update no 200:');
                        console.error(response.data);
                    } else if (response.data.code == "00") {
                        this.trainList.ActivityList = response.data.talkList;
                        this.trainList.pageItemNum = response.data.allcnt;
                        this.trainList.HasMore = this.trainList.pageItemNum < (this.trainList.Curpage + 1) * 10 ? false : true;
                        this.handleTalk2Activity(response.data.talkList, response.data.characters);
                    } else {
                        this.$message({ message: response.data.message, type: 'error' });
                        this.freshState = 'error';
                    }
                } catch (error) {
                    console.error('Failed to update:', error);
                    this.freshState = 'error';
                    this.$message({
                        message: '网络异常，请稍后重试',
                        type: 'error'
                    });
                }
            },
            sortAllactivityList() {
                this.activityList= [...this.activityList].sort((a, b) => {
                    return new Date(b.fulltime) - new Date(a.fulltime);
                });
            },
            async getMainDync() {
                console.log("sssssssssss");
                console.log(this.dyncSelect);
                switch (this.dyncSelect) {
                    case this.tabs[0].value://all
                        //this.activityList.splice(0, this.activityList.length);
                        await this.getListenInfos();
                        await this.genQuestionnaireList();
                        await this.getHistoryTalk();
                        this.sortAllactivityList();
                        break;
                    case this.tabs[1].value://conclusion
                        //this.activityList.splice(0, this.activityList.length);
                        console.log(this.activityList);
                        await this.getListenInfos();
                        
                        this.sortAllactivityList();
                        break;
                    case this.tabs[2].value://evaluation
                        //this.activityList.splice(0, this.activityList.length);
                        console.log(this.activityList);
                        await this.genQuestionnaireList();
                        this.sortAllactivityList();
                        break;
                    case this.tabs[3].value://visitor
                        //this.activityList.splice(0, this.activityList.length);
                        console.log(this.activityList);
                        await this.getHistoryTalk();
                        break;
                }
            },

            handleButtonClick(item) {
                console.log(item);
                if(item.text.startsWith("AI来访")){
                    this.gotoTrain();
                } else if (item.text.startsWith("来访管理")) {
                    this.isVisitorListVisible = true;
                }else if(item.text.startsWith("智能化心理测评")){
                    this.toggleOverlay();
                }else if(item.text.startsWith("智能化咨询记录")){
                    this.toggleUpLoad();
                }
            },
        },

        created() {
            if (!this.selectedEdition && this.editionList && this.editionList.length > 0) {
                this.selectedEdition = this.editionList[0].editionName;
            }
            this.initDyncParams();
            this.checkTokenAndFetchUserInfo();
            //this.updateToken();
            this.getAllVisitors();
            this.activityList.splice(0, this.activityList.length);
            this.getMainDync();
            this.fetchCharacters();
            this.visitorFilter();//TODO 这里可能需要处理。
        }
    };
</script>

<style>
    @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400;500;700&display=swap');
    @import url('https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');
    /* 定义slide-down过渡的CSS */
    .header_style {
        background: linear-gradient(135deg, #4299e1, #2c5282, #1a365d);
    }
    .innerai {
        overflow: hidden;
        height: 0;
        transition: 0.5s;
    }

    .outai:hover .innerai {
        height: 160px;
    }

    ul {
        list-style: none; /* 去掉默认的列表样式 */
    }

    .scrollable {
        max-height: calc(100vh - 10rem); /* 调整为你想要的高度 */
        overflow-y: auto; /* 开启 Y 轴滚动 */
    }

        /* 自定义滚动条样式 */
        .scrollable::-webkit-scrollbar {
            width: 4px; /* 滚动条宽度 */
        }

        .scrollable::-webkit-scrollbar-thumb {
            background-color: #eee3e9; /* 滚动条颜色 */
            border-radius: 4px; /* 圆角 */
        }

            .scrollable::-webkit-scrollbar-thumb:hover {
                background-color: #555; /* 悬停时的颜色 */
            }

        .scrollable::-webkit-scrollbar-track {
            background: #fff; /* 滚动条轨道颜色 */
        }

    body {
        font-family: 'Noto Sans SC', sans-serif;
    }

    .tab-slider {
        transition: transform 0.3s ease;
    }

    #app {
        text-align: center;
        position: relative; /* 为内容设置相对定位 */
    }

    .btn {
        padding: 10px 20px;
        font-size: 16px;
        cursor: pointer;
    }

    .custom-dialog {
        margin-top: 10px; /* 设置距离顶部的距离 */
    }

    .overlay {
        position: fixed; /* 固定定位 */
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色 */
        z-index: 1000; /* 确保覆盖层在最上面 */
    }

    .el-input__suffix {
        display: flex;
        align-items: center;
        height: 100%; /* 使后缀高度与输入框一致 */
    }

    /* 滑动动画 */
    .slide-enter-active, .slide-leave-active {
        transition: transform 0.3s ease;
    }

    .slide-enter-from, .slide-leave-to {
        transform: translateX(-100%);
    }

    .slide-enter-to, .slide-leave-from {
        transform: translateX(0);
    }

    /* 淡入淡出动画 */
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s ease;
    }

    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }

    /* 移动端优化样式 */
    @media (max-width: 768px) {
        /* 按钮和交互元素增大点击区域 */
        .el-button, button, [role="button"] {
            min-height: 44px;
            min-width: 44px;
        }

        /* 表单元素优化 */
        .el-input__inner {
            height: 44px;
            font-size: 16px; /* 防止iOS缩放 */
        }

        /* 卡片阴影简化 */
        .shadow-lg {
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        /* 优化滚动体验 */
        .overflow-y-auto {
            -webkit-overflow-scrolling: touch;
        }

        /* 来访者头像大小调整 */
        .v-avatar {
            width: 36px;
            height: 36px;
        }

        /* 活动卡片调整 */
        .activity-card {
            margin: 0.5rem 0;
            padding: 1rem;
        }
    }
    .mobile-container {
        width: 100%;
        max-width: 500px; /* 模拟移动端宽度，可根据实际调整 */
        margin: 0 auto;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        background-color: #fff;
    }

    /* 顶部功能按钮区样式 */
    .top-buttons {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        padding: 10px 0;
        border-bottom: 1px solid #eee;
    }

    .button-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
    }

    .button-icon {
        width: 50px;
        height: 50px;
        border-radius: 8px;
    }

    .button-text {
        margin-top: 5px;
        font-size: 12px;
    }

    /* 中间辅助功能区样式 */
    .sub-functions {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        padding: 10px 0;
        border-bottom: 1px solid #eee;
    }

    .sub-function-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
    }

    .func-icon {
        font-size: 20px;
        margin-right: 5px;
    }

    .func-text {
        font-size: 14px;
    }

    .badge {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: red;
        margin-left: 3px;
    }

    /* 导航栏样式 */
    .tab-bar {
        display: flex;
        flex-direction: row;
        overflow-x: auto;
        padding: 10px 0;
        border-bottom: 1px solid #eee;
    }

    .tab-item {
        flex: 0 0 auto;
        padding: 0 15px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
        white-space: nowrap;
    }

        .tab-item.active {
            color: #7B61FF;
            font-weight: bold;
            border-bottom: 2px solid #7B61FF;
        }

    /* 内容列表区样式 */
    .content-list {
        padding: 10px;
    }

    .content-item {
        border: 1px solid #eee;
        border-radius: 8px;
        padding: 10px;
        margin-bottom: 10px;
    }

    .item-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 5px;
    }

    .tag {
        padding: 2px 6px;
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        margin-right: 5px;
    }

    .item-title {
        font-size: 16px;
        font-weight: bold;
    }

    .item-subtitle {
        font-size: 13px;
        color: #999;
        margin-bottom: 5px;
    }

    .item-desc {
        font-size: 14px;
        color: #666;
        line-height: 1.4;
        margin-bottom: 5px;
    }

    .item-time {
        font-size: 12px;
        color: #999;
        text-align: right;
    }
</style>
